<h1 class="border-gray border-bottom text-center pb-4 mb-5">Product Ranges</h1>
<app-inline-menu></app-inline-menu>
<div class="text-end pb-4 mt-4">
	<button [routerLink]="['edit/new']"
		class="btn btn-primary btn-round btn-slim">
		Add new range
	</button>
</div>
<div class="row g-4 row-cols-2 row-cols-md-3 mb-4">
	<div class="col">
		<div class="card bg-white h-100 border-0 shadow-sm hover">
			<div class="card-body d-flex flex-column">
				<div class="fs-6 text-muted">
					Available Product Ranges
				</div>
				<div class="fs-2 fw-bold mt-auto">
					{{this.data.length}}
				</div>
			</div>
		</div>
	</div>
</div>
<div class="card border-0 bg-white shadow-sm mb-4">
	<div class="card-body p-xl-5">
		<div *ngIf="!data.length"
			class="no-results">
			<p>
				No product ranges found
			</p>
		</div>
		<div *ngIf="data.length"
			class="table-responsive">
			<table class="table table-borderless align-middle custom-wrap">
				<thead class="thead-white">
					<tr>
						<th class="text-primary fs-5 fw-600 text-nowrap">Name</th>
						<th class="text-primary fs-5 fw-600 text-nowrap">Supplier</th>
						<th class="text-primary fs-5 fw-600 text-nowrap">Has products?</th>
						<th class="text-primary fs-5 fw-600 text-nowrap">Actions</th>
					</tr>
				</thead>
				<tbody>
					<ng-container *ngFor="let s of data">
						<tr class="toplined">
							<td>{{s.name}}</td>
							<td>{{s.supplierName}}</td>
							<td>
								<i *ngIf="s.hasProducts"
									class="fa fa-check text-success"></i>
							</td>
							<td>
								<a [routerLink]="['edit', s.slug]">
									<img src="assets/images/icon-edit.svg" class="custom-edit-icon">
								</a>
								<a *ngIf="!s.hasProducts"
									(click)="deleteConfirm(s)"
									class="ms-3">
									<img src="assets/images/icon-trash.svg" class="custom-delete-icon">
								</a>
							</td>
						</tr>
						<ng-container *ngFor="let sg of s.subGroups">
							<tr class="hover">
								<td>{{sg.id}}</td>
								<td>{{sg.name}}</td>
								<td>{{sg.slug}}</td>
								<td>
									<a [routerLink]="['edit', sg.slug]">
										<!-- <i class="fa fa-edit"></i> -->
										<img src="assets/images/icon-edit.svg" class="custom-edit-icon">
									</a>
								</td>
							</tr>
						</ng-container>
					</ng-container>
				</tbody>
			</table>
		</div>
		<app-pagination *ngIf="params.pageArray.length"
			[params]="params"
			(update)="findAll()"></app-pagination>
	</div>
</div>
<app-confirmation *ngIf="this.confirmationData.open"
	[data]="confirmationData"
	(complete)="delete($event)"></app-confirmation>
